module.exports = __webpack_public_path__ + "media/wyposazenie/kraj-pochodzenia@2x-e49cb0eb.png";